module.exports = __webpack_public_path__ + "img/standardJGYL.897b1e92.png";